import { getSubscription } from 'components/Authentication/SignUpForm/types';
import { COUPON_TYPES } from 'components/Authentication/SignUpForm/types';
import _ from 'lodash';

// for all api methods throw an exception if something fails handleError in actions will catch the error and display a message

export class Api {

  constructor() {
    this.store = null;
    this.user = null;
    this.apiUrl = "https://admin.goboxpdx.com/api/v2";
  }

  async initialize(store) {
    this.store = store;
    const user = localStorage.getItem('_loginData');

    if (user) {
      this.user = JSON.parse(user);
      this.store.dispatch({ type: 'SET_USER', user: this.user });
      return this.user;
    }
    return null;
  }

  fetchJson = async (path, {
    authorize = false, method = 'POST', headers = {}, body, ...extra
  }) => {
    const token = authorize ? JSON.parse(localStorage.getItem('_loginData')) : undefined;

    headers = _.pickBy({
      'Content-Type': body ? 'application/json' : undefined,
      'Authorization': authorize ? `Bearer ${token.accessToken}` : undefined,
      ...headers,
    });

    if (body && !(body instanceof FormData)) {
      body = JSON.stringify(body);
    }

    const result = await fetch(this.apiUrl + path, _.pickBy({
      method,
      headers,
      body,
      ...extra,
    }));

    if (result.status === 401 && authorize) {
      this.logout();
      return;
    }

    const json = await result.json().catch(_.stubObject);
    return { status: result.status, data: json };
  };

    login = async (loginData) => {
    const { status, data } = await this.fetchJson("/login", { body: loginData });
  
    if (status === 200) {
      const user = {
        accessToken: data.data.accessToken,
        apiToken: data.data.apiToken,
        id: data.data.userId,
        refreshToken: data.data.refreshToken,
      };
      this.user = user;
      this.store.dispatch({ type: 'SET_USER', user });
      localStorage.setItem("_loginData", JSON.stringify(user));
      return true;
    }
  
    throw new Error(data.error);
  };

  logout() {
    localStorage.clear();
    this.store.dispatch({ type: 'SET_USER', user: null });
    this.user = null;
    return true;
  };

  signup = async (signupData) => {
    const { status, data } = await this.fetchJson('/register', { body: signupData });

    if (status === 200) {
      const { email, password} = signupData;
      await this.login({ email, password });
      return status;
    }

    if (status === 400) {
      throw new Error('Looks like a Bold Reuse account with this email address already exists.');
    }
    
    throw new Error(data.error);
  }

  createSubscription = async (subscriptionInfo) => {
    const { status } = await this.fetchJson('/register/payup', { authorize: true, body: subscriptionInfo, method: 'PATCH' });
    await this.getProfile();
    await this.getTransactions();

    return status;
  }

  getProfile = async () => {
    const { status, data } = await this.fetchJson('/me', { authorize: true, method: 'GET' });

    if (status === 200) {
      return { ...data.data, subscriptionPlan: getSubscription(data?.data?.subscriptionPlan)};
    }

    if (status === 500) {
      throw new Error("We couldn't get your info, please try again later");
    }
    
    throw new Error(data.error);
    }

  forgotPassword = async (forgotPassword) => {
    const { status, data } = await this.fetchJson('/forgot-password', { body: forgotPassword });

    if (status === 200) {
      return status;
    }

    if (status === 404) {
      throw new Error("No account was found for this email address. Please verify it and try again.");
    }
    throw new Error(data.error);
  }

  getTransactions = async () => {
  const { status, data } = await this.fetchJson('/me/stripePortal', { authorize: true, method: 'GET' });
  if (status === 200) {
    return data;
  }

  if (status === 500) {
    return;
  }

  throw new Error(data.error);
}

  validateCoupon = async (couponData) => {
    const {status, data} = await this.fetchJson('/coupon', { method: 'POST', body:couponData });
    if (status === 200) {
        if(data.data.percent_off !== null){
            return({
                type: COUPON_TYPES.percent,
                value: data.data.percent_off / 100,
                ...couponData
            })
        }else{
            return({
                type: COUPON_TYPES.price,
                value: data.data.amount_off / 100,
                ...couponData
            })
        } 
    }

    throw new Error("No valid coupon with the code you entered exists");
  }

}

